import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ModalState {
    value: boolean;
}

const initialState: ModalState = {
    value: false
}

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        showModal: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
})

export const {showModal} = modalSlice.actions;

export default modalSlice.reducer;